/* eslint-disable no-use-before-define */
import React from 'react'
import Box from '@material-ui/core/Box'
import Badge from 'ui/components/badge'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconArrowDown } from 'assets/icons/arrow-down.svg'
import useStyles from './autocompleteChipsStyles'

const AutocompleteChips = props => {
  const {
    options,
    placeholder,
    value,
    setValue,
    id,
    noOptionsText,
    applyWrap = false,
  } = props
  const classes = useStyles()

  const valHtml = value.map(option => {
    const label = option.name || option
    return (
      <Badge
        key={label}
        label={label}
        title={label}
        onDelete={() => {
          setValue(value.filter(entry => entry !== option))
        }}
        style={applyWrap ? { overflow: 'auto' } : {}}
      />
    )
  }, applyWrap)

  return (
    <>
      <Autocomplete
        fullWidth
        multiple
        popupIcon={<SvgIcon component={IconArrowDown} />}
        id={id}
        filterSelectedOptions
        options={options}
        onChange={(_, newValue) => setValue(newValue)}
        getOptionLabel={option => option.name}
        renderTags={() => {}}
        value={value}
        renderInput={params => (
          <TextField {...params} variant="outlined" placeholder={placeholder} />
        )}
        noOptionsText={noOptionsText}
        className={applyWrap ? 'flexWrap' : 'flexNoWrap'}
      />
      <Box mt={2}>
        <Grid container className={classes.chipsWrapper}>
          {valHtml}
        </Grid>
      </Box>
    </>
  )
}

export default AutocompleteChips
